export default __webpack_public_path__ + "static/media/bird.d8cc5015.png";